import { serialize, populate, queryStringToProps } from "../formUtils.js"

export class Filters {
  constructor() {
    this.baseUrl = window.location.pathname
    this.defaults = {
      "date-range": "future-dates",
      "from-date": "",
      "to-date": "",
      start: "0",
      topics: [],
      regions: [],
    }
    this.props = { ...this.defaults, ...queryStringToProps(window.location.search) }
    // Whether or not we have an active request
    this.inProgress = false

    this.initComponents()
    this.bindEvents()
    this.showSummaries()
    this.render()
  }

  initComponents() {
    this.banner = document.querySelector(".banner")

    this.form = document.querySelector("form[name=blog__filters]")

    this.radioButtonContainers = document.querySelectorAll(".date-range-btn")
    this.radioButtons = document.querySelectorAll("input[name='date-range']")
    this.filterButtons = document.querySelectorAll(".event-filter-button")
    this.radioButtonAllPast = document.querySelector("input#past-dates")
    this.radioButtonAllFuture = document.querySelector("input#future-dates")

    this.datePickerContainers = document.querySelectorAll(".date-picker-container")
    this.datePickers = document.querySelectorAll("input.date-picker")
    this.datePickerFrom = document.querySelector("input[name='from-date']")
    this.datePickerTo = document.querySelector("input[name='to-date']")

    this.filters = document.querySelectorAll(".blog__filter")

    this.container = document.querySelector(".blog__article-summaries")
    this.summaries = document.querySelectorAll(".article-summary")
    this.spinner = document.querySelector(".gwrc-loading")
  }

  bindEvents() {
    this.radioButtons.forEach(button => {
      button.addEventListener("change", () => {
        this.buttonAction(button)
      })
    })

    this.datePickers.forEach(datePicker => {
      datePicker.addEventListener("change", () => {
        this.pushFormStateToHistory()
        this.getArticles()
      })
    })

    this.filterButtons.forEach(button => {
      button.addEventListener("click", e => {
        e.preventDefault()
        const filter = document.getElementById(button.dataset.target)
        if (filter) {
          // Set aria-toggled true for clicked filter button
          button.setAttribute("aria-toggled", "true")

          // Set aria-toggled false for all other filter buttons
          this.filterButtons.forEach(btn => {
            if (btn !== button && btn.getAttribute("aria-toggled") === "true") {
              btn.setAttribute("aria-toggled", "false")
            }
          })

          filter.checked = true
          filter.dispatchEvent(new Event("change"))
        }
      })
    })

    // Bind standard browser events out here
    this.filters.forEach(filter => {
      filter.addEventListener("selectr.init", () => {
        // Bind custom selectr events once they have initialised
        filter.selectr.on("selectr.change", () => {
          if (!filter.selectr.eventsDisabled) {
            this.props[filter.name] = [...new Set(filter.selectr.getValue())]
            this.pushFormStateToHistory()
            this.getArticles()
          }
        })
        filter.selectr.on("selectr.deselect", option => {
          if (!filter.selectr.eventsDisabled) {
            if (this.props[filter.name].includes(option.value)) {
              this.props[filter.name] = this.props[filter.name].filter(a => a !== option.value)
            }
          }
        })
      })
    })

    // Browser back/forward events will re-populate form values
    window.onpopstate = () => {
      // update props from url
      this.props = { ...this.defaults, ...queryStringToProps(window.location.search) }

      // update view
      this.render()

      this.getArticles()
    }
  }

  updateCustomDateRange() {
    this.datePickerFrom.value = this.props["from-date"]
    this.datePickerTo.value = this.props["to-date"]
  }

  buttonAction(button) {
    // update props
    this.props["date-range"] = button.id

    if (button.getAttribute("data-date-range")) {
      const selectedRange = JSON.parse(button.getAttribute("data-date-range"))
      this.props = { ...this.props, ...selectedRange }
      this.updateCustomDateRange()
    }
    //update the props value from URL when toggle Past or Future
    const newUrlValue = { ...queryStringToProps(window.location.search) }
    if (newUrlValue["topics"] && newUrlValue["topics"].length > 0) {
      this.props["topics"] = newUrlValue["topics"]
    } else if (newUrlValue["regions"] && newUrlValue["regions"].length > 0) {
      this.props["regions"] = newUrlValue["regions"]
    }

    // update view
    this.pushFormStateToHistory(this.props)
    this.render()

    // all buttons except show/hide datepicker make a request
    const excludeRangeButton = button.id !== "custom-range"
    if (excludeRangeButton) {
      this.getArticles()
    }
  }

  pushFormStateToHistory(data) {
    // eslint-disable-next-line compat/compat
    const queryParams = data ? serialize(data, false) : serialize(this.form)

    window.history.pushState({}, "", this.baseUrl + "?" + queryParams)
  }

  render() {
    populate(this.form, this.props)
    this.toggleDatePickers()

    // Set aria-toggled attributes for filter buttons based on current state
    this.filterButtons.forEach(button => {
      const filter = document.getElementById(button.dataset.target)
      if (filter && filter.checked) {
        button.setAttribute("aria-toggled", "true")
      } else {
        button.setAttribute("aria-toggled", "false")
      }
    })
  }

  toggleDatePickers() {
    // Show / hide
    const visible = this.props["date-range"] === "custom-range"
    this.datePickerContainers.forEach(datePickerContainer => {
      if (visible) {
        datePickerContainer.classList.add("show")
        setTimeout(() => {
          datePickerContainer.classList.add("up")
        }, 10)
      } else {
        datePickerContainer.classList.remove("show")
        datePickerContainer.classList.remove("up")
      }
    })
  }

  /**
   * This will get articles based on current url
   */
  getArticles() {
    // Skip AJAX request if request is already in progress
    if (this.inProgress) {
      return
    }

    // update view
    this.spinner.style.display = "block"
    this.container.innerHTML = null

    // Set AJAX request is in progress
    this.inProgress = true

    // send request
    var xhr = new XMLHttpRequest()
    xhr.open("GET", window.location.href)
    xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest")
    xhr.onload = () => this.replaceArticles(xhr.status, xhr.response)
    xhr.send()
  }

  replaceArticles(status, articleHtml) {
    this.spinner.style.display = "none"
    // Set AJAX request is completed
    this.inProgress = false

    this.container.innerHTML = articleHtml
    this.summaries = document.querySelectorAll(".article-summary")
    this.showSummaries()
  }

  showSummaries() {
    this.summaries.forEach((summary, index) => {
      let delay = index * 150
      setTimeout(this.fadeIn(summary), delay)
    })
  }

  fadeIn(summary) {
    return function() {
      summary.style.opacity = 1
    }
  }
}

export default function init() {
  if (document.querySelector(".EventHub")) {
    new Filters()
  }
}
